import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]

  connect() {
    if (this.slideTargets.length <= 1) return
    this.current = 0
    this.interval = setInterval(() => this.next(), 5000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  next() {
    this.slideTargets[this.current].classList.add("hidden")
    this.current = (this.current + 1) % this.slideTargets.length
    this.slideTargets[this.current].classList.remove("hidden")
  }
}
